<template>
  <div class="card" id="mycard">

<!--    <div class="card-title bg-success-800 panel-title"  style="padding-left: 15px;padding-top: 10px;" >-->
<!--      <h4>-->
<!--        <span class="font-weight-semibold">  <span v-if="voucher.code > 0" > {{voucher.doc_no}} : </span>  Fuel Purchase Invoice</span> Information-->
<!--      </h4>-->
<!--    </div>-->

    <div class="card-header header-elements-inline bg-indigo-600" >
      <h5 v-if="voucher.code == 0" class="card-title">Fuel Purchase Invoice Creation</h5>
      <h5 v-if="voucher.code > 0" class="card-title"> Doc No: {{voucher.doc_no}} Fuel Purchase Invoice Updation</h5>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" data-action="reload" @click="loadData" ></a>
          <a class="list-icons-item" data-action="remove" @click="closeThis"></a>
        </div>
      </div>
    </div>




    <div class="card-body">

      <div class="row">

        <div class="col-md-3">
          <div class="form-group form-group-material">
            <label class="control-label font-weight-semibold">Supplier</label>
            <select id="cmbledger" class="form-control" autofocus="" required="" v-if="voucher"  v-model="voucher.ledger.code" @change="enableAddButton" >
              <option v-for="ledger in ledgers" v-bind:value="ledger.code">
                {{ ledger.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-1">
          <div class="form-group form-group-material">
            <!--            <label class="control-label font-weight-semibold">Type</label>-->
            <!--            <select class="form-control select" required="" v-if="voucher"  v-model="voucher.type" @change="enableAddButton" >-->
            <!--              <option value="301">B2B</option>-->
            <!--              <option value="302">B2C</option>-->
            <!--              <option value="303">Composition</option>-->
            <!--              <option value="304">Exempted</option>-->
            <!--              <option value="305">Imported</option>-->
            <!--              <option value="306" selected>NonGST</option>-->
            <!--              <option value="307">In Eligible</option>-->
            <!--              <option value="308">RCM</option>-->
            <!--              <option value="300">Others</option>-->
            <!--            </select>-->
          </div>
        </div>

        <div class="col-md-3">

        </div>
        <div class="col-md-2">
          <!--          <div class="form-group form-group-material">-->
          <!--            <label class="control-label  font-weight-semibold">A/c Date</label>-->
          <!--            <input type="date" class="form-control" v-if="voucher" v-model="voucher.doc_date" placeholder="Ac Date" >-->
          <!--          </div>-->
        </div>

        <div class="col-md-1">
          <div class="form-group form-group-material">
            <label class=" control-label font-weight-semibold">Invoice No</label>
            <input type="text" class="form-control" placeholder="Invoice No" minlength="0" maxlength="30" v-if="voucher" v-model="voucher.ref_no">
          </div>
        </div>


        <div class="col-md-2">
          <div class="form-group form-group-material">
            <label class="control-label  font-weight-semibold">Invoice Date</label>
            <input type="date" class="form-control text-right" v-if="voucher" v-model="voucher.doc_date" placeholder="Invoice Date" >
          </div>
        </div>

      </div>

      <div class="row">
        <!--  Detail Table -->
        <div class="table-responsive">

          <table id="mytable" class="table table-no-bordered">
            <thead style="background-color: lightgrey">
            <tr>
              <th style="width:50px;">S.No</th>
              <th >Item</th>
              <th style="width:75px; text-align: right;">Qty</th>
              <th style="width:100px; text-align: right;">Rate</th>
              <th style="width:100px; text-align: right;">Taxable</th>
              <th style="width:100px; text-align: right;">DLY</th>
              <th style="width:100px; text-align: right;">TAX%</th>
              <th style="width:100px; text-align: right;">Tax Amt</th>
              <th style="width:150px; text-align: right;">Net Amount</th>
              <th style="width: 30px;">Action</th>
            </tr>

            </thead>
            <tbody v-for="(detail,index) in voucher.list" >
              <InvoiceDetail :vchtype="voucher.type"  :items="detailItems" :myindex="index" :myrow="detail" v-on:onrow_change="onrow_change" v-on:onRemoveRow="removeRow"  > </InvoiceDetail>
            </tbody>
            <tfoot>
            <tr>
              <td>
                <button id="btnAddRow" type="button" class="btn border-success text-success-800 btn-flat btn-icon btn-rounded legitRipple" @click="addRow"  :disabled="addRowButtonDisabled">
                  <i class="icon-plus3"></i>
                </button>
              </td>
              <td></td>
              <td class="text-right" >{{ rowQtyTotal }}</td>
              <td class="text-right" ></td>
              <td class="text-right" >&#8377;<span >{{ indianFormat(rowTaxableTotal) }}</span></td>
              <td class="text-right" >&#8377;{{ indianFormat(rowDlyTotal) }}</td>
              <td class="text-right" ></td>
              <td class="text-right" >&#8377;<span >{{ indianFormat(rowTaxTotal) }}</span></td>
              <td class="text-right" >&#8377;<span >{{ indianFormat(rowAmountTotal) }}</span></td>

              <td></td>

            </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!-- / Detail Table -->


      <div class="row">
        <div class="col-md-3">
          <div class="form-group form-group-material">
            <label class="control-label font-weight-semibold">Vehicle No</label>
            <input  type="text" class="form-control text-uppercase" placeholder="Vehicle No"  v-if="voucher" v-model="voucher.vehicleno" maxlength="12" />
          </div>
        </div>


        <div class="col-md-6">
          <h3 style="font-size: 48px;color: blue">
            <!--voucher.gross_amount-->
            &#8377;<span style="padding-right: 15px;">{{ indianFormat( rowAmountTotal + parseFloat(voucher.round_off) ) }}</span>
          </h3>
        </div>

        <div class="col-md-3 text-right">
          <div class="form-group row">
            <label class="col-form-label col-md-4 font-weight-semibold">Round Off</label>
            <div class="col-md-8">
              <input id="txtroundoff" type="number" class="form-control text-right" placeholder="Round Off Value" v-if="voucher" v-model="voucher.round_off" >
            </div>
          </div>

          <div class="form-group row">
            <!--            <label class="col-form-label col-md-4 font-weight-semibold">TDS</label>-->
            <!--            <div class="col-md-8">-->
            <!--              <input id="txttds" type="number" class="form-control text-right" placeholder="Round Off Value" v-if="voucher" v-model="voucher.tds_amt" >-->
            <!--            </div>-->
          </div>

          <button id="btnSave" type="button" class="btn bg-green-800 btn-raised active" @click="saveVoucher">Save</button>
          <button id="btnclose" type="button" class="btn btn-default" data-dismiss="" @click="clear" >Clear</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'
  import numeral from 'numeral'
  import GstPanel from '@/components/v1/gst/GstPanel.vue'
  import InvoiceDetail from '@/components/core/FuelInvoiceDetailRow.vue'
  import { store } from '@/store/store.js'
  export default {
    name: 'FuelInvoiceForm',
    components: {
      InvoiceDetail
    },
    store,
    props: {
      myvoucher: {
        type: Object,
        default: () => JSON.parse('{"id":"","code":0,"ver":0,"status":0,"is_cr":"Y","type":306,"ibr":1,"finyear":2019,"series":302,"doc_date":"0001-01-01","doc_no":0,"ref_no":"","ref_date":"0001-01-01","ledger":{"id":"","code":0,"type":306,"group_code":0,"name":"","print_name":"","street":"","city":"","pin":"","state_cd":0,"gstin":"","contact_person":"","telephone":"","email":""},"eway_no":"","eway_date":"0001-01-01","vehicle_no":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":"","sys_obj":false},"remarks":"","gross_amount":0,"tax_amount":0,"round_off":0,"net_amount":0, "tds_amt":0, "list":[]}')
      }
    },
    beforeMount () {
      const self = this;
      const requestOptions = {
        method: 'GET',
        mode:"cors",
        headers: userService.authHeader()
      };


      if( this.myvoucher.code > 0 ) {

        this.voucher = this.myvoucher;
        this.sumRowAmountTotal();
        this.voucher.round_off = this.voucher.round_off.toFixed(2);

      }
    },
    data () {
      return {
        addRowButtonDisabled:false,
        readonly: false,
        ledgers:[],
        detailItems:[],
        items : new Map(),
        rowQtyTotal:0.0,
        rowAmountTotal: 0.0,
        rowIgstTotal:0.0,
        rowDlyTotal:0.0,
        rowTaxTotal:0.0,
        rowTaxableTotal:0.0,
        voucher: JSON.parse('{"_id":"","code":0,"status":0,"locked":false,"type":306,"ibr":0,"finyear":0,"series":0,"doc_date":"0001-01-01","doc_no":"","ref_date":"0001-01-01","ref_no":"","ledger":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","group":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","parent":0,"nature":0,"level":0,"is_profit":false,"is_subledger":false,"is_net_bal":false},"open_bal":0,"gstin":"","add":{"name":"","street":"","city":"","pin":"","state_cd":0,"email":"","tel":"","mobile":""}},"remarks":"","vehicleno":"","gross_amount":0,"tax_amount":0,"round_off":0,"net_amount":0,"list":[],"maker":""}'),
      }
    },
    created () {
      let self = this;
      self.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
      self.$data.voucher.ref_date = moment().format('YYYY-MM-DD');
    },
    mounted () {
      let self = this;
      self.loadData();

      // self.$data.addRowButtonDisabled = true;
      if (self.$data.voucher.doc_date === '0001-01-01'){
        self.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
        self.$data.voucher.ref_date = moment().format('YYYY-MM-DD');
      }
    },
    methods:{
      indianFormat(val){
        return parseFloat(val).toFixed(2);
      },
      closeThis () {

        if (this.voucher.code > 1) {

          this.$emit('fuleinvoice_window_closed');
          this.$modal.hide('fuleinvoice_window');
          this.$data.voucher = JSON.parse('{"_id":"","code":0,"status":0,"locked":false,"type":306,"ibr":0,"finyear":0,"series":0,"doc_date":"0001-01-01","doc_no":"","ref_date":"0001-01-01","ref_no":"","ledger":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","group":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","parent":0,"nature":0,"level":0,"is_profit":false,"is_subledger":false,"is_net_bal":false},"open_bal":0,"gstin":"","add":{"name":"","street":"","city":"","pin":"","state_cd":0,"email":"","tel":"","mobile":""}},"remarks":"","vehicleno":"","gross_amount":0,"tax_amount":0,"round_off":0,"net_amount":0,"list":[],"maker":""}');
        } else {
          this.$router.push('/');
        }
      },
      enableAddButton(){

        let self = this;
        this.ledgers.forEach(function (ldgr) {

          if(self.$data.voucher.ledger.code == ldgr.code){
            self.$data.voucher.ledger =  JSON.parse(JSON.stringify(ldgr));
          }
        });


        this.$data.voucher.list = [];
        this.$data.addRowButtonDisabled = (this.$data.voucher.ledger.code > 1 &&  this.$data.voucher.type == 0);
      },
      addRow(){
        try {
          let self = this;
          self.$data.voucher.list.push(JSON.parse('{"idx":0,"item":{"_id":"","code":0,"name":"","unit":6},"unit":2,"rate":0,"qty":0,"taxable_amt":0,"dly_amt":0,"tax_rate":0,"tax_amt":0,"net_amt":0}'));

        }catch (e) {
          alert(e);
        }
      },
      calculate_gst(detail){

        var taxrate = 0;
        if  (this.$data.voucher.type == 301 || this.$data.voucher.type == 307) {
          taxrate = detail.gst_rate;
        }

        let tax_value = Math.round(detail.qty * detail.rate * (taxrate / 100) * 100);
        if (tax_value % 2 !== 0) {
          tax_value++;
        }
        tax_value = tax_value / 100;

        detail.tax_amt = tax_value;

        detail.igst_amt = 0;
        detail.sgst_amt = tax_value / 2;
        detail.cgst_amt = tax_value / 2;

      },
      onrow_change(rowIndex, colIndex) {
        let self = this;
        let tax_value = 0;

        let detail = self.$data.voucher.list[rowIndex];
        // switch (colIndex) {
        //   case 1:
        //     detail.item = self.$data.items.get(detail.item.code);
        //     detail.gst_rate = parseFloat(detail.item.group.gstrate);
        //     break;
        //   case 2: //GST Rate
        //     detail.gst_rate = parseFloat(detail.item.group.gstrate);
        //     console.log(detail.gst_rate);
        //     break;
        //   case 3://Product Rate
        //     // tax_value = Math.round(detail.qty * detail.rate * (detail.gst_rate/100) * 100);
        //     // if (tax_value%2 !== 0 ){
        //     //   tax_value++;
        //     // }
        //     // tax_value = tax_value/100;
        //     detail.taxable_amt = numeral(detail.qty * detail.rate).format('0.00');
        //
        //     self.calculate_gst(detail);
        //     // detail.tax_amt = numeral(tax_value).format('0.00');
        //     detail.net_amt = numeral(parseFloat(detail.taxable_amt) + parseFloat(detail.tax_amt)).format('0.00');
        //     break;
        //   case 4://Product Qty
        //
        //     // tax_value = Math.round(detail.qty * detail.rate * (detail.gst_rate/100) * 100);
        //     // if (tax_value%2 !== 0 ){
        //     //   tax_value++;
        //     // }
        //     // tax_value = tax_value/100;
        //     detail.taxable_amt = numeral(detail.qty * detail.rate).format('0.00');
        //     self.calculate_gst(detail);
        //     // detail.tax_amt = numeral(tax_value).format('0.00');
        //     detail.net_amt = numeral(parseFloat(detail.taxable_amt) + parseFloat(detail.tax_amt)).format('0.00');
        //     break;
        //   case 5://Taxable value
        //
        //     // detail.taxable_amt = parseFloat(detail.taxable_amt);
        //     // detail.rate = numeral(detail.taxable_amt / detail.qty).format('0.00');
        //     self.calculate_gst(detail);
        //     // detail.tax_amt = numeral(parseFloat(detail.taxable_amt) * (detail.gst_rate/100)).format('0.00');
        //     detail.net_amt = numeral(parseFloat(detail.taxable_amt) + parseFloat(detail.tax_amt)).format('0.00');
        //     break;
        //   case 6:
        //   case 7:
        //   case 8:
        //     detail.tax_amt = numeral(parseFloat(detail.igst_amt) + parseFloat(detail.cgst_amt) + parseFloat(detail.sgst_amt)).format('0.00');
        //     detail.net_amt = numeral(parseFloat(detail.taxable_amt) + parseFloat(detail.tax_amt)).format('0.00');
        //     break;
        // }
        self.$data.rowQtyTotal = 0.0;
        self.$data.rowAmountTotal = 0.0;
        self.$data.rowIgstTotal = 0.0;
        self.$data.rowDlyTotal = 0.0;
        self.$data.rowTaxTotal = 0.0;
        self.$data.rowTaxableTotal = 0.0;
        self.$data.voucher.list.forEach(function (detail) {

          self.$data.rowQtyTotal += parseFloat(detail.qty);
          self.$data.rowAmountTotal += parseFloat(detail.net_amt);
          self.$data.rowTaxTotal += parseFloat(detail.tax_amt);
          self.$data.rowDlyTotal += parseFloat(detail.dly_amt);
          self.$data.rowTaxableTotal += parseFloat(detail.taxable_amt);
        });
      },
      removeRow(index){
        if (index > -1) {
          this.$data.voucher.list.splice(index, 1);
          this.sumRowAmountTotal();
        }
      },
      sumRowAmountTotal() {
        let self = this;

        self.$data.rowQtyTotal = 0.0;
        self.$data.rowAmountTotal = 0.0;
        self.$data.rowIgstTotal = 0.0;
        self.$data.rowDlyTotal = 0.0;
        self.$data.rowTaxTotal = 0.0;
        self.$data.rowTaxableTotal = 0.0;
        self.$data.voucher.list.forEach(function (detail) {
          self.$data.rowQtyTotal += parseFloat(detail.qty);
          self.$data.rowAmountTotal += parseFloat(detail.net_amt);
          self.$data.rowIgstTotal += parseFloat(detail.igst_amt);
          self.$data.rowTaxTotal += parseFloat(detail.sgst_amt);
          self.$data.rowDlyTotal += parseFloat(detail.cgst_amt);
          self.$data.rowTaxableTotal += parseFloat(detail.taxable_amt);
        });
      },
      clear(){
        $('#btnSave').prop('disabled', false);
        let self = this;
        self.$data.voucher = JSON.parse('{"_id":"","code":0,"status":0,"locked":false,"type":306,"ibr":0,"finyear":0,"series":0,"doc_date":"0001-01-01","doc_no":"","ref_date":"0001-01-01","ref_no":"","ledger":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","group":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","parent":0,"nature":0,"level":0,"is_profit":false,"is_subledger":false,"is_net_bal":false},"open_bal":0,"gstin":"","add":{"name":"","street":"","city":"","pin":"","state_cd":0,"email":"","tel":"","mobile":""}},"remarks":"","vehicleno":"","gross_amount":0,"tax_amount":0,"round_off":0,"net_amount":0,"list":[],"maker":""}');
        self.$data.voucher.voucherDate = moment().format('YYYY-MM-DD');
        self.$data.voucher.referenceDate = moment().format('YYYY-MM-DD');
        self.$data.voucher.list = [];
        self.$data.rowAmountTotal = 0.0;
        self.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
        self.$data.voucher.ref_date = moment().format('YYYY-MM-DD');
        self.$data.addRowButtonDisabled = false;
        self.$data.rowQtyTotal = 0.0;
        self.$data.rowAmountTotal = 0.0;
        self.$data.rowIgstTotal = 0.0;
        self.$data.rowDlyTotal = 0.0;
        self.$data.rowTaxTotal = 0.0;
        self.$data.rowTaxableTotal = 0.0;
        $('#cmbledger').focus();
      },
      loadData() {
        let self = this;


        if( self.$data.items.size == 0 ){
          //Fetch Detail Ledgers
          self.$data.detailItems = [{"code":101,"name":"Petrol","hsn":"","gstrate":0,"salerate":76.06,"porder":-4},{"code":102,"name":"Diesel","hsn":"","gstrate":0,"salerate":69.9,"porder":-2},{"code":103,"name":"Speed","hsn":"","gstrate":0,"salerate":79.03,"porder":-1}];
          self.$data.items = new Map();

          self.$data.detailItems.forEach(function (itm) {
            Object.freeze(itm);
            self.$data.items.set(itm.code, itm);
          });
        }


        const requestOptions = {
          mode:'cors',
          headers: userService.authHeader()
        };


        //fetch the Ledgers
        self.$data.ledgers = [];
        fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xbunk/oilcompany/`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.accepted){
            self.$data.ledgers.push(resp.data);
          }else{
            swal (  {title:"Oops" ,  text: resp.msg,  type: "error"});
          }
        }).catch(function (err) {
          swal (  {title:"Oops" ,  text: err.toString(),  type: "error"});
        });



      },
      saveVoucher(){
        const self = this;

        if (self.$data.voucher.list.length < 1){
          swal({title:'Info',text:'Invalid Invoice Detail', type:'error'});
          return;
        }

        try{
          $('#mycard').block({
            message: '<i class="icon-spinner2 spinner"></i>',
            overlayCSS: {
              backgroundColor: '#fff',
              opacity: 0.8,
              cursor: 'wait',
              'box-shadow': '0 0 0 1px #ddd'
            },
            css: {
              border: 0,
              padding: 0,
              backgroundColor: 'none'
            }
          });


          let myvoucher =  JSON.parse(JSON.stringify(self.$data.voucher));

          myvoucher.finyear = store.state.user.finyear;
          myvoucher.type = parseInt(self.$data.voucher.type);
          myvoucher.doc_date = moment(self.$data.voucher.doc_date).format('YYYY-MM-DD');// + 'T00:00:00Z';
          myvoucher.ref_date = moment(self.$data.voucher.ref_date).format('YYYY-MM-DD');// + 'T00:00:00Z';

          myvoucher.round_off = parseFloat(self.$data.voucher.round_off);
          myvoucher.gross_amount = self.$data.rowAmountTotal;
          myvoucher.net_amount = myvoucher.gross_amount + myvoucher.round_off;
          myvoucher.ibr =  parseInt(localStorage.getItem('branch_code'));

          myvoucher.list.forEach(function (detail){
            detail.tax_rate = parseFloat(detail.tax_rate);
            detail.qty = parseFloat(detail.qty);
            detail.unit = 6;
            detail.rate = parseFloat(detail.rate);
            detail.taxable_amt = parseFloat(detail.taxable_amt);
            detail.tax_rate = parseFloat(detail.tax_rate);
            detail.tax_amt = parseFloat(detail.tax_amt);
            detail.dly_amt = parseFloat(detail.dly_amt);
            detail.net_amt = parseFloat(detail.net_amt);
          });


          const requestOptions = {
            method:  (self.$data.voucher.code == 0 ? 'POST' : 'PUT' ),
            mode:'cors',
            headers: userService.authHeader(),
            body: JSON.stringify(myvoucher)
          };


          $('#btnSave').prop('disabled', true);
          fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xbunk/fuelpurchase/`,requestOptions).then(userService.handleResponse).then(function (resp) {
            if (resp.accepted){
              swal({ title: 'Great', type: 'success', text: resp.msg});
              $('#mycard').unblock();

              if(self.$data.voucher.code > 0){
                self.$emit('invoice_saved');
              }

              self.clear();

            }else{
              $('#btnSave').prop('disabled', false);
              $('#mycard').unblock();
              swal (  {title:"Oops" ,  text: resp.msg,  type: "error"});
            }
          }).catch(function (err) {
            $('#mycard').unblock();
            $('#btnSave').prop('disabled', false);
            swal (  {title:"Oops" ,  text: err.toString(),  type: "error"});
          });

        }catch (e) {

        }finally {

        }



      }
    }
  }
</script>

<style scoped>
</style>
